import React from 'react';
import { useTranslation } from 'react-i18next';
import { DrillholeList } from './DrillholeList';
import { FaTrash } from 'react-icons/fa';
import { formatDateTime } from '../../i18n/format';



export const ProjectSummary = ({ project, summaries, handleDrillholeSelect, handleMapUpdated, handleProjectDelete }) => {
    const { t } = useTranslation();

    let contents = <p><em>{t('projects.selectProjectPrompt')}</em></p>;

    if (project.name) {
        contents = (
            <div>
                <h3>{project.name}</h3>
                <button className="btn btn-danger ms-auto" onClick={() => handleProjectDelete(project.name)}><FaTrash /> {t('projects.deleteProject')}</button>
                <p>{project.description}</p>
                <p>{t('common.createdOn', { date: formatDateTime(project.created) })}</p>
                <DrillholeList projectName={project.name} drillholes={project.drillholes} summaries={summaries} handleDrillholeSelect={handleDrillholeSelect} handleMapUpdated={handleMapUpdated} />
            </div>
        );
    }

    return (
        <div>
            {contents}
        </div>
    );
}
